<template>
	<transition name="error">
		<div class="regions"
		     @scroll="scrollPopup">
			<button @click="showRegPopup"
			        v-show="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"
			>добавить новый регион</button>
			<p class="right">список регионов</p>
			<transition name="error">
				<p class="exist isOk" v-if="savedSuccess">успешно сохранено!</p>
				<p class="exist" v-if="error">ошибка при создании региона</p>
				<p class="exist isOk" v-if="deleteOk">регион успешно удален</p>
				<p class="exist" v-if="errorDelete">регион не был удален</p>
			</transition>
			<transition enter-active-class="animated fadeIn faster"
			            leave-active-class="animated fadeOut faster"
			            :key="'remove'">
				<div class="container-fluid flex-column position-absolute justify-content-center h-100 main"
				     id="remove"
				     v-show="deletingReg">
					<div class="container bg-light col-lg-8 col-md-8 col-xl-7 col-sm-8 p-5 popup">
						<div class="flex-column justify-content-center">
							<div class="title cont">вы действительно хотите удалить регион {{ this.deletingName }}?</div>
							<div class="container justify-content-around cont mt-3">
								<button class="btn btn-outline-danger button"
								        @click="deleteReg">удалить</button>
								<button class="btn btn-outline-dark button"
								        @click="cancel">отменить</button>
							</div>
						</div>
					</div>
				</div>
			</transition>
			<transition enter-active-class="animated fadeIn faster"
			            leave-active-class="animated fadeOut faster"
			            :key="'add'">
				<div class="container-fluid flex-column position-absolute justify-content-center h-100 main"
				     id="add"
				     v-show="addedReg">
					<div class="container bg-light col-lg-8 col-md-8 col-xl-7 col-sm-8 p-5 popup">
						<div class="container align-items-start justify-content-between text-center">
							<label for="name"
							       class="label mb-1">Имя на сервера</label>
							<input class="input"
							       type="text"
							       id="name"
							       autocomplete="off"></div>
						<div class="container  align-items-start justify-content-between text-center">
							<label for="display_name"
							       class="label mb-1 mt-3">Отображаемое имя</label>
							<input class="input"
							       type="text"
							       id="display_name"
							       autocomplete="off"></div>
						<div class="container  align-items-start justify-content-between text-center"
						     v-if="getReqUserRole === 'Администратор уровня Бог' && getViewUser === 'root'">
							<label for="operator"
							       class="label mb-1 mt-3">Оператор</label>
							<select name="operator"
							        class="input"
							        v-model="selectOperator"
							        id="operator">
								<option v-for="operator in operatorList"
								        :value="operator.name"
								        :key="operator.display_name">{{operator.display_name}}
								</option>
							</select>
						</div>
						<div class="container justify-content-around cont mt-4 mb-3">
							<button class="btn btn-outline-success button" @click="createNewReg">добавить</button>
							<button class="btn btn-outline-dark button" @click="cancel">отменить</button>
						</div>
						<transition enter-active-class="animated fadeInUp"
						            leave-active-class="animated fadeOutDown">
							<p class="text-danger mb-0 pb-0 position-absolute err_handler" v-if="correct">{{ messageError }}</p>
						</transition>
					</div>
				</div>
			</transition>
			<transition enter-active-class="animated fadeIn faster"
			            leave-active-class="animated fadeOut faster"
			            :key="'edit'">
				<div class="container-fluid flex-column position-absolute justify-content-center h-100 main"
				     id="edit"
				     v-show="showEditPopup">
					<div class="container bg-light col-lg-8 col-md-8 col-xl-7 col-sm-8 p-5 popup">
						<div class="container align-items-start justify-content-between text-center">
							<label for="editname"
							       class="label mb-1">Имя на сервера</label>
							<input class="input"
							       type="text"
							       id="editname"
							       v-model="editReg.name"
							       autocomplete="off"></div>
						<div class="container  align-items-start justify-content-between text-center">
							<label for="editdisplay_name"
							       class="label mb-1 mt-3">Отображаемое имя</label>
							<input class="input"
							       type="text"
							       id="editdisplay_name"
							       v-model="editReg.display_name"
							       autocomplete="off"></div>
						<div class="container  align-items-start justify-content-between text-center"
						     v-if="getReqUserRole === 'Администратор уровня Бог' && getViewUser === 'root'">
							<label for="editoperator"
							       class="label mb-1 mt-3">Оператор</label>
							<select name="operator"
							        class="input"
							        v-model="editReg.operator"
							        id="editoperator">
								<option v-for="operator in operatorList"
								        :value="operator.name"
								        :key="operator.display_name">{{operator.display_name}}
								</option>
							</select>
						</div>
						<div class="container justify-content-around cont mt-4 mb-3">
							<button class="btn btn-outline-success button" @click="updateReg">сохранить</button>
							<button class="btn btn-outline-dark button" @click="cancel">отменить</button>
						</div>
						<transition enter-active-class="animated fadeInUp"
						            leave-active-class="animated fadeOutDown">
							<p class="text-danger mb-0 pb-0 position-absolute err_handler" v-if="correct">{{ messageError }}</p>
						</transition>
					</div>
				</div>
			</transition>
			<div class="container">
				<div class="row justify-content-between p-2 pl-5 pb-2 card-header">
					<span class="w-25 h5">имя</span>
					<span class="w-25 h5">отображаемое имя</span>
					<span class="w-25 h5"
					      v-if="getReqUserRole === 'Администратор уровня Бог'"
					>оператор</span>
					<span class="w-25"></span>
				</div>
				<div class="row justify-content-between p-2 pl-5 list"
				     v-for="region in regionList"
				     :key="region.display_name">
					<span class="w-25">{{region.name}}</span>
					<span class="w-25">{{region.display_name}}</span>
					<span class="w-25"
					      v-if="getReqUserRole === 'Администратор уровня Бог'"
					>{{region.operator}}</span>
					<span class="w-25 text-center">
					<button
						class="btn btn-danger mt-1"
						v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"
						@click="deletePopup(region.name, region.operator)">delete
					</button>
					<button
						class="btn btn-outline-info mt-1"
						v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"
						@click="editPopup(region, region.name)">edit
					</button>
				</span>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
	import { performRequest } from "../script/ws/wsclient";
	import { mapGetters }     from "vuex";

	export default {
		name:     "Regions",
		data() {
			return {
				savedSuccess:   false,
				error:          false,
				deleteOk:       false,
				errorDelete:    false,
				regionList:     [],
				deletingReg:    false,
				addedReg:       false,
				correct:        false,
				messageError:   "",
				operatorList:   null,
				selectOperator: "",
				showEditPopup:  false,
				deletingName:   "",
				editReg:        {
					name:         "",
					display_name: "",
					operator:     "",
					old_name:     ""
				}

			};
		},
		beforeMount() {
			this.getReg();
			if (this.getReqUserRole === "Администратор уровня Бог") {
				this.getOperators();
			}
		},
		computed: {
			...mapGetters(
				[
					"getReqUserRole",
					"getViewUser"
				]
			)
		},
		methods:  {
			scrollPopup() {
				let elem              = document.querySelector(".regions");
				let addedPopup        = document.querySelector("#add");
				let deletePopup       = document.querySelector("#remove");
				let editPopup         = document.querySelector("#edit");
				addedPopup.style.top  = elem.scrollTop + "px";
				deletePopup.style.top = elem.scrollTop + "px";
				editPopup.style.top   = elem.scrollTop + "px";
			},
			getOperators() {
				performRequest(
					{
						section: "tvcontent.operator",
						name:    "getOperatorList"
					},
					{
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							this.operatorList = a.data;
							console.log(a);
						} else {
							console.log("ошибка загрузки списка операторов");
						}
					});
			},
			getReg() {
				performRequest(
					{
						section: "tvcontent.region",
						name:    "getRegionList"
					},
					{
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							this.regionList                                    = a.data;
							document.querySelector(".regions").style.overflowY = "scroll";
							console.log(a);
						} else {
							console.log("ошибка загрузки списка операторов");
						}
					});
			},
			editPopup(region, name) {
				this.showEditPopup                                 = true;
				document.querySelector(".regions").style.overflowY = "hidden";
				this.editReg.name                                  = region.name;
				this.editReg.display_name                          = region.display_name;
				this.editReg.operator                              = region.operator;
				this.editReg.old_name                              = name;
				console.log();
			},
			updateReg() {
				if (document.querySelector("#editname").value !== "" &&
					document.querySelector("#editdisplay_name").value !== "") {
					this.editReg.operator = this.getViewUser;
					performRequest(
						{
							section: "tvcontent.region",
							name:    "updateRegion"
						},
						this.editReg,
						a => {
							if (a.code === 200) {
								this.showEditPopup  = false;
								this.selectOperator = "";
								this.getReg();
							}
							if (a.code === 400) {
								this.errorHandler("введены не корректные данные");
							}
							if (a.code === 500) {
								this.errorHandler("ошибка на сервере");
							}
							else {
								console.log("ошибка =(((");
							}
						});
				} else {
					this.errorHandler("все поля должны быть заполнены");
				}
			},
			showRegPopup() {
				this.addedReg                                      = true;
				document.querySelector(".regions").style.overflowY = "hidden";
			},
			createNewReg() {
				if (document.querySelector("#name").value !== "" &&
					document.querySelector("#display_name").value !== "") {
					let data = {
						name:         document.querySelector("#name").value.trim(),
						display_name: document.querySelector("#display_name").value.trim()
					};
					if (this.getReqUserRole === "Администратор уровня Бог") {
						data.operator = this.selectOperator;
					}
					data.operator = this.getViewUser;
					performRequest(
						{
							section: "tvcontent.region",
							name:    "createRegion"
						},
						data,
						a => {
							if (a.code === 200) {
								this.addedReg                                     = false;
								this.selectOperator                               = "";
								document.querySelector("#name").value             = "";
								document.querySelector("#display_name").value     = "";
								document.querySelector("#editname").value         = "";
								document.querySelector("#editdisplay_name").value = "";
								this.getReg();
							}
							if (a.code === 400) {
								this.errorHandler("введены не корректные данные");
							}
							if (a.code === 500) {
								this.errorHandler("ошибка на сервере");
							}
							else {
								console.log("ошибка =(((");
							}
						});
				} else {
					this.errorHandler("все поля должны быть заполнены");
				}


			},
			cancel() {
				this.deletingReg                                   = false;
				this.addedReg                                      = false;
				this.showEditPopup                                 = false;
				document.querySelector(".regions").style.overflowY = "scroll";
			},
			deletePopup(name, operator) {
				this.deletingReg                                   = true;
				this.deletingName                                  = name;
				this.deletingOperator                              = operator;
				document.querySelector(".regions").style.overflowY = "hidden";
			},
			deleteReg() {
				let data = {
					name: this.deletingName,
				};
				if (this.getReqUserRole === "Администратор уровня Бог") {
					data.operator = this.deletingOperator;
				}
				data.operator = this.getViewUser;
				performRequest(
					{
						section: "tvcontent.region",
						name:    "deleteRegion"
					},
					data,
					a => {
						if (a.code === 200) {
							this.getReg();
							this.deletingReg      = false;
							this.deletingName     = "";
							this.deletingOperator = "";

						} else {
							console.log("ошибка загрузки списка операторов");
						}
					});
			},
			errorHandler(value) {
				this.messageError = value;
				if (!this.correct) {
					this.correct = true;
					setTimeout(() => {
						this.correct = false;
					}, 2500);
				}
			}
		}
	};
</script>
<style scoped lang="scss">
	@import "~bootstrap/scss/bootstrap";
	$width_container_button: 24px;
	$width_button_item: $width_container_button - 8;
	$height_button: 2px;
	$height_add: 208px;
	$width_add: $height_add / 4;
	$bd_button: 8px;
	
	.regions {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
		/*padding: 0.5rem 0.5rem 1rem 0.5rem;*/
		height: calc(100vh - 5rem);
		overflow: auto;
		position: absolute;
		margin-top: 4rem;
		width: 90%;
		right: 50%;
		min-width: 700px;
		max-width: 1200px;
		transform: translateX(50%);
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: flex-start;
		align-content: flex-start;
		.right {
			position: absolute;
			top: 7px;
			right: 20px;
		}
	}
	.exist {
		background-color: rgba(238, 160, 154, 0.6);
		border-radius: 5px;
		padding: 4px 10px 5px 10px;
		top: 6px;
		font-weight: bold;
		position: absolute;
		margin-left: 30%;
		color: #940000;
		font-size: 1.1rem;
		z-index: 1000;
	}
	.isOk {
		background-color: rgba(137, 238, 154, 0.6);
		color: #008d94;
	}
	.btn {
		padding: 0 1rem;
		height: 3rem;
		min-width: 5rem;
		margin: 0;
	}
	.list {
		border-top: 1px solid rgba(44, 62, 80, 0.47);
		transition: background-color .3s;
		&:hover {
			background-color: rgba(128, 140, 166, 0.33);
		}
		&:last-child {
			border-bottom: 1px solid rgba(44, 62, 80, 0.47);
		}
	}
	.w-25 {
		cursor: default;
	}
	.label {
		width: 200px;
	}
	.main {
		background-color: rgba(130, 130, 130, 0.27);
	}
	.input {
		width: 70%;
		height: 1.8rem;
		outline: none;
		border: 1px solid gray;
		border-radius: 3px;
		transition: all .3s;
		padding-left: 5px;
		&:focus {
			border: 1px solid #acafff;
			box-shadow: 0 0 7px #acafff;
		}
	}
	.popup {
		top: 50%;
		transform: translateY(-50%);
	}
	.err_handler {
		bottom: 1.5rem;
		font-size: 1.1rem;
		left: 3.8rem;
	}
	.cont {
		text-align: center;
	}
	.button {
		max-height: 2rem;
	}
	button {
		background: #bbf291;
		border-radius: 0.2rem;
		line-height: 1.8rem;
		margin: 1rem;
		border: none;
		outline: none;
		height: 2.5rem;
		padding: 0.2rem 1rem;
		transition: all 0.2s;
		cursor: pointer;
		max-height: 2rem;
		&:hover {
			background: #78956b;
			color: white;
			
			&:active {
				box-shadow: 0 0 1rem #967068;
			}
		}
	}
	@media (max-width: 620px) {
		.regions {
			height: calc(100vh - 9rem);
			min-width: 700px;
			margin-top: 8rem;
			overflow: auto;
		}
	}
	.error-enter-active {
		transition: all 0.5s ease;
	}
	.error-leave-active {
		transition: all 0.5s ease;
	}
	.error-enter,
	.error-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Regions.vue